import angular from 'angular'
import component from './component'

export default angular
  .module('ellipsis.linkMenu', [])
  .component('linkMenu', component)
